import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeAcManagerList = (data) => {
	return {
		type: Types.STORE_ACCOUNT_MANAGER_LIST,
		payload: data
	};
};

export const fetchAccountManagerList =
	(params = '?userTypeList=ACCOUNT_MANAGER&page=0&size=1000') =>
	async (dispatch) => {
		await ApiClient.GET('userSearch', params).then((response) => {
			dispatch(storeAcManagerList(response.data.data));
		});
	};
